import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ViewModeOption } from '../../../../../cross-team-shared/toolbars/layer-settings/layer-view-settings.component';

@Component({
  selector: 'h3-vector-tagging-layer-view-settings',
  templateUrl: './vector-tagging-layer-view-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VectorTaggingLayerViewSettingsComponent {
  viewModeOptions: ViewModeOption[] = [
    { viewMode: 'all', tooltip: 'All' },
    { viewMode: 'selected', tooltip: 'Selected' },
    { viewMode: 'none', tooltip: 'None' },
  ];
}
